import { Image } from 'components'

// css
import 'assets/style/common.scss'

export default function MenuRecipCook({ dataList = [] }) {
  return (
    <>
      {dataList.length > 0 ? (
        <ul className="menu-recipep-3">
          {dataList.map((item, index) => (
            <li key={`cook_${index}`} style={{ alignItems: 'initial' }}>
              <div className="img-wrap">
                <Image
                  src={process.env.REACT_APP_MENU_IMAGE_URL + '/' + item.imgPathUrl || ''}
                  alt="이미지"
                  className="thumb"
                />
              </div>
              <p>{item.cokWayCn}</p>
            </li>
          ))}
        </ul>
      ) : (
        <div className="flex-1 flex-align-center" style={{ marginTop: '40px' }}>
          <div className="flex-col flex-item-center">
            <span className="icon-message-gray"></span>
            <p className="c-6 mt24">등록된 조리법이 없습니다. </p>
          </div>
        </div>
      )}
    </>
  )
}
